<template>
  <i class="fa-solid fa-check"></i>
</template>